import { useReducer, useEffect } from 'react';
import ChartPie from '../../components/charts/chartPie/ChartPie';
import AddMenu from '../../components/forms/addMenu/AddMenu';
import EditMenu from '../../components/forms/editMenu/EditMenu';
import MenuParams from '../../components/forms/menuParams/MenuParams';
import Table from '../../components/tables/table/Table';
// import Carregar from '../../components/forms/carregar/Carregar';

const initialTableState = {
  showMenuParams: false,
  showPie: false,
  showPieClicked: false,
  hideEdit: true,
  hideCarregar: true,
  propData: null,
  pieData: {},
  RSUCarregado: null
};

function tableReducer(state, action) {
  switch (action.type) {
    case 'TOGGLE_MENU_PARAMS':
      return { ...state, showMenuParams: !state.showMenuParams };
    case 'TOGGLE_PIE':
      return { ...state, showPie: !state.showPie };
    case 'TOGGLE_PIE_CLICKED':
      return { ...state, showPieClicked: !state.showPieClicked };
    case 'TOGGLE_HIDE_EDIT':
      return { ...state, hideEdit: !state.hideEdit };
    case 'TOGGLE_HIDE_CARREGAR':
      return { ...state, hideCarregar: !state.hideCarregar };
    case 'SET_PROP_DATA':
      return { ...state, propData: action.payload };
    case 'SET_PIE_DATA':
      return { ...state, pieData: action.payload };
    case 'SET_RSU_CARREGADO':
      return { ...state, RSUCarregado: action.payload };
    default:
      return state;
  }
}

function TablePatter(props) {
  const { estimagasState, estimagasDispatch, defaultParams, dataFetch } = props;
  const [tableState, tableDispatch] = useReducer(tableReducer, initialTableState);

  useEffect(() => {
    if (tableState.RSUCarregado && tableState.RSUCarregado.length !== 0) {
      estimagasDispatch({ type: 'RES_DATA', payload: tableState.RSUCarregado });
      estimagasDispatch({ type: 'TOGGLE_LOAD_TABLE' });
    }
    defaultParams();
  }, [tableState.RSUCarregado]);

  const limparDados = () => {
    estimagasDispatch({ type: 'RES_DATA', payload: [] });
    estimagasDispatch({ type: 'TOGGLE_LOAD_TABLE' });
  }

  const resetarDados = async () => {
    let data = await dataFetch();
    estimagasDispatch({ type: 'RES_DATA', payload: data });
    estimagasDispatch({ type: 'TOGGLE_LOAD_TABLE' });
    defaultParams();
  }

  const reOrdenar = () => {
    let tempDados = [...estimagasState.resData];
    estimagasDispatch({ type: 'TOGGLE_INVERT' });
    tempDados.sort((a, b) => estimagasState.invert ? parseFloat(a.ano) - parseFloat(b.ano) : parseFloat(b.ano) - parseFloat(a.ano));
    estimagasDispatch({ type: 'RES_DATA', payload: tempDados });
    estimagasDispatch({ type: 'TOGGLE_LOAD_TABLE' });
  }

  return (
    <div className='w-full'>
      <div className='text-center h-48'>
        <AddMenu estimagasState={estimagasState} estimagasDispatch={estimagasDispatch} />
        {!tableState.hideEdit && <EditMenu estimagasState={estimagasState} estimagasDispatch={estimagasDispatch} setHideEdit={() => tableDispatch({ type: 'TOGGLE_HIDE_EDIT' })} propData={tableState.propData} />}
        {tableState.showMenuParams && <MenuParams estimagasState={estimagasState} estimagasDispatch={estimagasDispatch} tableDispatch={tableDispatch}/>}
      </div>

      <div className="flex flex-row">
        <div className="text-center mt-8 flex-grow">
          <div className={"text-stone-200 bg-amber-600 border border-red-600 w-3/5 rounded-xl m-auto mt-16"}>
            <button onClick={resetarDados}>Dados de Residuos Sólidos urbanos(RSU)</button>
          </div>
          <Table 
            resetarDados={resetarDados}
            resData={estimagasState.resData}
            dispatch={estimagasDispatch} 
            hideEdit={tableState.hideEdit} 
            setHideEdit={(value) => tableDispatch({ type: 'TOGGLE_HIDE_EDIT' })} 
            setPieData={(data) => tableDispatch({ type: 'SET_PIE_DATA', payload: data })} 
            setShowPie={() => tableDispatch({ type: 'TOGGLE_PIE' })} 
            setShowPieClicked={() => tableDispatch({ type: 'TOGGLE_PIE_CLICKED' })} 
            showPieClicked={tableState.showPieClicked} 
            setPropData={(data) => tableDispatch({ type: 'SET_PROP_DATA', payload: data })} 
            propData={tableState.propData} 
          />
        </div>
        <div className="flex flex-col mt-12 w-60 items-center">
          <button id="chart-btn-params" className="table-button-menu" onClick={() => tableDispatch({ type: 'TOGGLE_MENU_PARAMS' })}>Outros parâmetros</button>
          <button id='clear-btn-total' className="table-button-menu" onClick={limparDados}>Limpar</button>
          <button id='inv-btn-total' className="table-button-menu" onClick={reOrdenar}>Inverter</button>
          <button title="Insere dados experimentais fornecidos pela companhia Rio Grandense de Valorização de Resíduos (CRVR)" id="reset-btn-total" className="table-button-menu" onClick={resetarDados}>Dados experimentais</button>
          {/* <div className=" text-center text-stone-100 p-1.5 pl-3 bg-rose-600 border-2 rounded-2xl border-red-700 inline-block cursor-pointer hover:border-red-400 hover:bg-orange-500 hover:text-stone-50"
           onClick={() => tableDispatch({ type: 'TOGGLE_HIDE_CARREGAR' })}>
            
            <img className='align-middle invert w-5' src={upIcon} alt='' />
            <button id='resultado-btn-total'>Carregar dados</button>
          </div> */}
        </div>
       
        {/* {!tableState.hideCarregar && <Carregar setFileData={(data) => tableDispatch({ type: 'SET_RSU_CARREGADO', payload: data })} hideCarregar={() => tableDispatch({ type: 'TOGGLE_HIDE_CARREGAR' })} />} */}
        <div className="flex-[0.5]"></div>
        {(tableState.showPie || tableState.showPieClicked) && <ChartPie pieData={tableState.pieData} showPie={tableState.showPie} showPieClicked={tableState.showPieClicked} />}
      </div>
    </div>
  );
}

export default TablePatter;